<template>
    <div :class="['task-field el-clear', errorMessages ? 'field-error' : '']">
        <slot name="pre-menu" :selected-accounts="localSelectedItems" :keepOnly="keepOnly" :remove="removePerson"></slot>
        <DropMenu
            :menu-state.sync="menu_open"
            :value="localSelectedItems"
            :items="items"
            :menu-props="{
                'open-on-hover': false,
                'attach': attachKey ? '#task_' + attachKey + '_users-menu' : false,
                'transition': false,
                'offset-y': true,
            }"
            :menu-min-width="171"
            multi
            deselect
            name-key="name"
            value-key="id"
            show-selected-first
            searchable
            avatars
            avatar-initials-key="initials"
            :avatar-circular-rule-func="() => false"
            :search-text="$t('Find member...')"
            :hide-select-all="hideSelectAll"
            @input="usersUpdated"
        >
            <template v-slot="{ on }">
                <div v-if="attachKey" :id="attachKey ? 'task_' + attachKey + '_users-menu' : ''">
                    <slot :selected-accounts="localSelectedItems" :menu-open="menu_open" :on="on"></slot>
                </div>
                <slot v-else :selected-accounts="localSelectedItems" :menu-open="menu_open" :on="on"></slot>
            </template>
        </DropMenu>
    </div>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import DropMenu from "../NewFilterBar/components/DropMenu";

export default {
    name: "UsersMenu",
    components: {
        DropMenu
    },
    props: {
        value: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        errorMessages: {
            type: String,
            default: null
        },
        openTowardsTop: {
            type: Boolean,
            required: false
        },
        eagerSave: {
            /*
             * Use when menu state is controlled by global state. Otherwise checkmarks are inaccurate.
             */
            type: Boolean,
            required: false,
            default: false
        },
        attachKey: {
            /*
             * If present, renders the menu inside a child DOM element to avoid activator hover state dysfunction. Must be unique.
             */
            type: [String, Number],
            required: false,
            default: null
        },
        hideSelectAll: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const menu_open = ref(false);
        const localSelectedItems = ref(props.items.filter(x => props.value.includes(x.id)));
        const preMenu = ref(null);

        const emitChange = () => {
            let selectedItemIds = localSelectedItems.value.map(x => x.id);
            if (!props.eagerSave) {
                if (selectedItemIds.sort().toString() !== props.value.sort().toString()) {
                    ctx.emit("change",  selectedItemIds );
                }
            } else {
                ctx.emit("change",  selectedItemIds );
            }
        }

        const usersUpdated = function(assignees) {
            localSelectedItems.value = assignees;
            if (props.eagerSave) {
                emitChange()
            }
        };

        watch(menu_open, function(val, prev_val) {
            if (prev_val === undefined || val === true) return;

            if (!props.eagerSave) {
                emitChange()
            }
        });

        const removePerson = person_id => {
            localSelectedItems.value = localSelectedItems.value.filter( assignee => assignee.id !== person_id);
            emitChange()
        }
        
        const keepOnly = person_id => {
            // leave me as assignee
            // all others should change to followers
            const selectedItemIds = localSelectedItems.value.map(x => x.id);
            const idsToRemove = selectedItemIds.filter(id => id !== person_id)
            ctx.emit("keep_only", { keep: [person_id], remove: idsToRemove });
        }

        watch(
            () => props.value,
            () => {
                localSelectedItems.value = props.items.filter(x => props.value.includes(x.id))
            }
        )

        return {
            menu_open,
            localSelectedItems,
            focus,
            blur,
            usersUpdated,
            removePerson,
            keepOnly,
            preMenu
        };
    }
};
</script>
